import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { NgbCollapseModule, NgbDatepickerModule, NgbTimepickerModule, NgbDropdownModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

import { PagetitleComponent } from './pagetitle/pagetitle.component';
import { LoaderComponent } from './loader/loader.component';
import { AuditBadgeComponent } from './audit-badge/audit-badge.component';
import { CustomerQuickAddPopupComponent } from './customer-quick-add-popup/customer-quick-add-popup.component';
import { ContactQuickAddPopupComponent } from './contact-quick-add-popup/contact-quick-add-popup.component';
import { OrderHistoryTimelinePopupComponent } from './order-history-timeline-popup/order-history-timeline-popup.component';
@NgModule({
  declarations: [
    PagetitleComponent,
    LoaderComponent,
    AuditBadgeComponent,
    CustomerQuickAddPopupComponent,
    ContactQuickAddPopupComponent,
    OrderHistoryTimelinePopupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbDropdownModule,
    NgbPopoverModule
  ],
  exports: [
    PagetitleComponent,
    LoaderComponent,
    AuditBadgeComponent,
    CustomerQuickAddPopupComponent,
    ContactQuickAddPopupComponent,
    OrderHistoryTimelinePopupComponent
  ]
})
export class UIModule { }
